import { getApiInstance } from './Api';
import { Universe } from '../Types/Universe';
import {
  generateAssetRenditionUrl,
  ImageFormat,
  ARTICLE_IMAGE_RENDITIONS,
  ARTICLE_ATTRIBUTE_IMAGE_RENDITIONS,
} from '../Utils/Assets';
import { mapUser } from './UserApi';
import { StorylineDilemma } from '../Types/StorylineDilemma';
import { mapStorylineDilemma } from './StorylineApi';

const mapUniverse = (universe: any): Universe => {
  const imageUrl = universe.imagePath
    ? new URL(
        universe.imagePath,
        universe.createdByUserId
          ? window.env.REACT_APP_MEDIA_BASE_URL
          : window.env.REACT_APP_SHARED_MEDIA_BASE_URL,
      ).toString()
    : null;

  return {
    id: universe.id,
    title: universe.title,
    description: universe.description,
    createdByUserId: universe.createdByUserId,
    createdByUser: universe.createdByUser && mapUser(universe.createdByUser),
    image: {
      originalUrl: imageUrl,
      compressedUrl: imageUrl
        ? generateAssetRenditionUrl(imageUrl, null, ImageFormat.WEBP)
        : null,
      thumbnailUrl: imageUrl
        ? generateAssetRenditionUrl(
            imageUrl,
            ARTICLE_ATTRIBUTE_IMAGE_RENDITIONS.THUMBNAIL,
            ImageFormat.WEBP,
          )
        : null,
    },
    createdAt: universe.createdAt && new Date(Date.parse(universe.createdAt)),
    updatedAt: universe.updatedAt && new Date(Date.parse(universe.updatedAt)),
    deletedAt: universe.deletedAt && new Date(Date.parse(universe.deletedAt)),
  };
};

export class UniverseApi {
  async getUniverses(): Promise<Universe[]> {
    const response = await getApiInstance().get('/universes');
    return response.data.map(mapUniverse);
  }

  async getUniverseById(id: string): Promise<Universe> {
    const response = await getApiInstance().get(`/universes/${id}`);
    return mapUniverse(response.data);
  }

  async createUniverse(
    title: string,
    description: string,
  ): Promise<{ universe: Universe; dilemmas: StorylineDilemma[] }> {
    const response = await getApiInstance().post('/universes', {
      title,
      description,
    });
    return {
      universe: mapUniverse(response.data.universe),
      dilemmas: response.data.dilemmas.map(mapStorylineDilemma),
    };
  }

  async editUniverse(
    universeId: string,
    title: string,
    description: string,
  ): Promise<Universe> {
    const response = await getApiInstance().put(`/universes/${universeId}`, {
      title,
      description,
    });
    return mapUniverse(response.data);
  }
}
